import { BASE_URL } from '../../../config';

export default ({ item }) => {
  return (
    <>
      <img src={(item?.message?.provider === 'whatsapp' ? BASE_URL : '') + item.message.body.sticker.url} style={{ maxHeight: '20px', maxWidth: '20px' }} />
    </>
  );
};
